export const MuiPaper = (palette) => ({
  outlined: {
    '&.MuiPaper-rounded': {
      border: `1px ${palette.common.colors.grey5} solid`
    }
  }
});
